// © Microsoft Corporation. All rights reserved.

import { TelemetryObjectBase, TelemetryType } from "@msnews/telemetry-contracts";
import { genericTelemetryClickDispatcher } from "@msnews/social-utils";

export interface ReactionMenuTelemetryObjects {
    container: TelemetryObjectBase;
    emojis: TelemetryObjectBase[];
}

export const reactionMenuTelemetryContracts = {
    container: { // ContentReaction>Scenario 2b impr
        name: "ReactionsPopup"
    },
    emojis: {  // ContentReaction>Scenario 2c & CommentReactions Scenario 2x
        type: TelemetryType.ActionButton
    }
};

export const reactionMenuTelemetryActionDispatchers = {
    emojiClick: genericTelemetryClickDispatcher
};